import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
const DARK =
  'skyType:color; skyColor:black; ground:flat; dressing:none; groundColor:black; groundTexture:none;playArea:0.1;';

export class EnvironmentElement extends AbstractBlock {
  constructor(name: string, title: string) {
    super(name, title);
    this.setNameForCode('a-entity');
    this.setLibrary(
      // 'https://unpkg.com/aframe-environment-component@1.2.0/dist/aframe-environment-component.min.js'
      '../public/libs/aframe-environment-component.min.js'
    );
    // this.setLibrary('https://unpkg.com/aframe-environment-component@1.0.0/dist/aframe-environment-component.min.js');
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setEnvironmentColor(block);
    ShapeSettings.setElementShape(block);

    const environment = new Blockly.FieldDropdown([
      // [t.to('フォレスト', 'forest'), 'preset:forest'],
      [
        t.to('フォレスト', 'forest'),
        `seed: 8; skyType:gradient; skyColor:#24b59f; horizonColor:#eff9b7; lighting:distant; lightPosition:-1.2 0.88 -0.55;fog: 0.8; flatShading: false; playArea: 1; ground:noise; groundYScale: 4.18; groundTexture: squares; groundColor:#937a24; groundColor2:#987d2e; dressing:trees; dressingAmount: 100; dressingColor:#888b1d; dressingScale: 1; dressingVariance:10 10 10; dressingUniformScale: true; dressingOnPlayArea: 0; grid: none; gridColor: #c5a543; shadow: false`,
      ],
      [
        t.to('草原（太陽）', 'meadow_sun'),
        'skyType:atmosphere;ground:hills;groundColor:green;groundColor2:seagreen;groundTexture:squares;',
      ],
      [
        t.to('草原（夜）', 'meadow_night'),
        'skyType:atmosphere;ground:hills;lightPosition:0 0.5 -0.2;lighting:distant;groundColor:green;groundColor2:seagreen;groundTexture:squares;',
      ],
      [
        t.to('湿地', 'wetlands'),
        'groundTexture:squares;ground:hills;skyType:atmosphere;groundColor:green;groundColor2:green',
      ],
      [
        t.to('パステル', 'pastel'),
        'skyType:atmosphere;ground:hills;groundYScale:30;groundColor:pink;groundColor2:yellow;groundTexture:squares;',
      ],
      [
        t.to('ゴールド', 'gold'),
        'skyType:atmosphere;ground:noise;groundYScale:2;groundColor:yellow;groundColor2:gold;groundTexture:walkernoise;',
      ],
      [t.to('デフォルト', 'env_default'), 'preset:default'],
      [t.to('コンタクト', 'contact'), 'preset:contact'],
      [t.to('エジプト', 'egypt'), 'preset:egypt'],
      [t.to('チェッカーボード', 'checkerboard'), 'preset:checkerboard'],
      [t.to('ゴアランド', 'goaland'), 'preset:goaland'],
      [t.to('ヤヴァパイ', 'yavapai'), 'preset:yavapai'],
      [t.to('ゴールドマイン', 'goldmine'), 'preset:goldmine'],
      [t.to('ツリータワー', 'threetowers'), 'preset:threetowers'],
      [t.to('ポイズン', 'poison'), 'preset:poison'],
      [t.to('アーチ', 'arches'), 'preset:arches'],
      [t.to('トロン', 'tron'), 'preset:tron'],
      [t.to('ジャパン', 'japan'), 'preset:japan'],
      [t.to('ドリーム', 'dream'), 'preset:dream'],
      [t.to('ボルケーノ', 'volcano'), 'preset:volcano'],
      [t.to('スターレイ', 'starry'), 'preset:starry'],
      [t.to('オシリス', 'osiris'), 'preset:osiris'],
      [t.to('暗闇', 'dark'), DARK],
    ]);
    ShapeSettings.setTitleField(block, this.title);
    block.appendDummyInput().appendField(environment, 'environment');
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const environment = CodeSetting.getFieldValue(block, 'environment');

    let attribute = CodeSetting.getSubAttributeCode(block);
    // attribute += " environment = ' preset : "  + preset + "' ";
    attribute += CodeSetting.getAttributeCode('environment', `${environment}`);

    const grandAtt =
      CodeSetting.getAttributeCode('opacity', `0`) +
      CodeSetting.getAttributeCode('ammo-body', `type: kinematic;`) +
      CodeSetting.getAttributeCode('ammo-shape', `type: box;`) +
      CodeSetting.getAttributeCode('class', `collidable`) +
      CodeSetting.getAttributeCode('position', `0 0 0`) +
      CodeSetting.getAttributeCode('scale', `1000 0 1000`);

    const opacityGrand = CodeSetting.getElementCode('a-box', grandAtt, block.id, '');

    const str =
      (environment ===
      'skyType:color; skyColor:black; ground:flat; dressing:none; groundColor:black; groundTexture:none;playArea:0.1;lighting;'
        ? `scene.style.backgroundColor ="black";\n`
        : '') +
      CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '') +
      opacityGrand;
    return str;
  }
}
